<template>
	<div class="loadItem">
		<div class="paymentHead">
			<item-info-row
					:is-item-icon="false"
					text="Rate:"
					:value="load.rate"
					margin="0"
					is-value-first-icon
					value-first-icon="icon_dollars"
					value-first-icon-width="8"
					value-first-icon-height="16"
			></item-info-row>
			<item-info-row
					:is-item-icon="false"
					text="Total:"
					:value="load.gross"
					margin="0"
					is-value-first-icon
					value-first-icon="icon_dollars"
					value-first-icon-width="8"
					value-first-icon-height="16"
			></item-info-row>
		</div>

		<div v-if="getListItems.length > 0">
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="getListItems"
					@updateClickButton="onClickButton($event, flag)"
					@updateClickButtonItemIndex="onClickButtonItemIndex($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import {
	tablePaymentsView,
	paymentsTypes,
	tablePaymentsViewCustomer
} from "@/components/Dispatch/Trips/DialogTrip/constants";
// Constants
import { PAGE } from "@/constants/constants";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { mapGetters } from "vuex";

export default {
	name: "PaymentsView",
	components: { ItemInfoRow },
	props: {
		load: Object,
	},
	computed: {
		...mapGetters([ 'isLogin' ]),
		getHeaders() {
			return this.isLogin.customers ? tablePaymentsViewCustomer : tablePaymentsView;
		},
		getListItems() {
			const originalArray = this.load.payments;
			const copyArray = originalArray.slice();
			const filteredArray = copyArray.filter(obj => obj.status !== 'delete');

			filteredArray.map(obj => {
				const paymentsType = paymentsTypes.filter(function(val) {
					if (val.id === obj.type) return val;
				});
				obj.typeName = paymentsType[0].value;

				obj.considerBoolean = obj.consider === 1;
			});
			return filteredArray;
		},
	},
	data() {
		return {
			flag: PAGE.TRIP_PAYMENTS,
			loadTotal: null,
			itemIndex: null
		};
	},
	methods: {

		onClickButtonItemIndex(index) {
			this.itemIndex = index;
		},
		onClickButton(args, nameComponent) {
			const { key, item } = args;
			const itemIndex = this.itemIndex;
			this.$emit('updateEditItem', { key, item, nameComponent, itemIndex });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
.loadItem {
	display: flex;
	flex-direction: column;
	gap: 10px;
	.paymentHead {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}
}
</style>
